import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Старый адрес карточки бота. До 18.10.2026 здесь было 25 раскрывашек на одном экране;
 * теперь они разошлись по экранам вкладки «Бот». Адрес оставлен редиректом: на него
 * ведут сводка, онбординг, кнопки «Назад» и ссылки из старых сообщений.
 *
 * `?open=` выбирает экран: brand → Оформление, payments → Тарифы и оплата (к способам
 * оплаты), site → вкладка «Бот» (витрина настраивается на сайте), без него → Настройки.
 */
export const Route = createFileRoute('/bots/$botId')({
  validateSearch: (search: Record<string, unknown>): { open?: string } =>
    typeof search.open === 'string' ? { open: search.open } : {},
  beforeLoad: ({ params, search }) => {
    const bot = params.botId;
    switch (search.open) {
      case 'brand':
        throw redirect({ to: '/bot/brand', search: { bot }, replace: true });
      case 'payments':
        throw redirect({ to: '/pricing', search: { botId: bot }, hash: 'payments', replace: true });
      case 'site':
        throw redirect({ to: '/bot', replace: true });
      default:
        throw redirect({ to: '/bot/settings', search: { bot }, replace: true });
    }
  },
});
